import axios from "@/services/axios";
import Vue from "vue";

const BASE_ADMIN_URL = "admin/";
const BASE_STUDENT_URL = "user/";
// 7-day average barely moves within a session; card views reuse it instead of
// refetching on every question/answer route change.
const TIME_STUDY_TTL_MS = 10 * 60 * 1000;
let timeStudyCache = { studentId: null, fetchedAt: 0 };

export default {
  async fetchStudentCardGroupList(context, payload) {
    const page = payload.page || 1;
    const limit = payload.limit || 10;
    const params = new URLSearchParams({ page, limit });
    if (payload.userGroupCardId) {
      params.set("userGroupCardId", payload.userGroupCardId);
    }
    await axios
      .get(`${BASE_ADMIN_URL}student/${payload.studentId}?${params.toString()}`)
      .then((res) => {
        if (res.data.status_code == "200") {
          context.commit("SET_CARD_GROUP_LIST", res.data.data);
          context.commit("SET_PAGINATION", res.data.data.pagination);
          Vue.prototype.$isProStudent = res.data.data.isPro;
        } else {
          const error = res.data.message || "Something is wrong!";
          throw error;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  async fetchTimeStudy(context, payload) {
    const studentId = String(payload.studentId);
    const isFresh =
      timeStudyCache.studentId === studentId &&
      Date.now() - timeStudyCache.fetchedAt < TIME_STUDY_TTL_MS;
    if (!payload.force && isFresh) return;
    await axios
      .post(`${BASE_STUDENT_URL}timeStudyAvg`, {
        userId: payload.studentId,
      })
      .then((res) => {
        if (res.data.status_code == "200") {
          timeStudyCache = { studentId, fetchedAt: Date.now() };
          context.commit("SET_TIME_STUDY_AVG", res.data.data);
        } else {
          const error = res.data.message || "Something is wrong!";
          throw error;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  async fetchStudentCardDetailInAGroupCard(context, groupCardId) {
    await axios
      .get(`${BASE_ADMIN_URL}student/groupCard/${groupCardId}`)
      .then((res) => {
        if (res.data.status_code == "200") {
          context.commit("SET_CARD_LIST", res.data.data);
          return "";
        } else {
          const error = res.data.message || "Something is wrong!";
          return error;
        }
      })
      .catch((error) => {
        console.log(error);
        return "Something is wrong!";
      });
  },
  async fetchCardListInAFolder(context, { folderId, studentId }) {
    await axios
      .get(
        `${BASE_ADMIN_URL}folders/learnCards?folderId=${folderId}&studentId=${studentId}`
      )
      .then((res) => {
        if (res.data.status_code == "200") {
          context.commit("SET_CARD_LIST", res.data.data);
          return "";
        } else {
          const error = res.data.message || "Something is wrong!";
          return error;
        }
      })
      .catch((error) => {
        console.log(error);
        return "Something is wrong!";
      });
  },
  async unassignGroupCard(context, groupCardId) {
    await axios
      .put(`${BASE_ADMIN_URL}student/groupCard/${groupCardId}`)
      .then((res) => {
        if (res.data.status_code !== "200") {
          const error = res.data.message || "Something is wrong!";
          throw error;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  async handleRemoveLearnCard(context, id) {
    await axios
      .delete(`${BASE_STUDENT_URL}cards/${id}`)
      .then((res) => {
        if (res.data.status_code !== "200") {
          const error = res.data.message || "Something is wrong!";
          throw error;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  async createRandomStudy(context, payload) {
    try {
      const res = await axios.post("user/cards/save-card/copy", payload);
      // Backend returns numeric 200; accept both string and number.
      if (res.data.status_code != "200") {
        return res.data.message || "Something is wrong!";
      }
      return "";
    } catch (error) {
      console.log(error);
      return (
        error?.response?.data?.message ||
        error?.message ||
        "Something is wrong!"
      );
    }
  },
  async deleteRandomStudy(context, payload) {
    await axios
      .post("user/cards/save-card/delete-copy", payload)
      .then((res) => {
        if (res.data.status_code !== "200") {
          const error = res.data.message || "Something is wrong!";
          return error;
        }
      })
      .catch((error) => {
        console.log(error);
        return "Something is wrong!";
      });
    return "";
  },
  async reviewAhead(context, payload) {
    context.commit("SET_LOADING", true);
    let mess = "";
    try {
      const res = await axios.post("user/cards-review-ahead", payload);
      if (res.data.status_code != "200") {
        mess = "Đã có lỗi xảy ra, vui lòng thử lại";
      }
    } catch (error) {
      console.log(error);
      mess = "Đã có lỗi xảy ra, vui lòng thử lại";
    }
    context.commit("SET_LOADING", false);
    return mess;
  },
  async reviewAheadFolder(context, payload) {
    context.commit("SET_LOADING", true);
    let mess = "";
    try {
      const res = await axios.post("user/folders-review-ahead", payload);
      if (res.data.status_code != "200") {
        mess = "Đã có lỗi xảy ra, vui lòng thử lại";
      }
    } catch (error) {
      console.log(error);
      mess = "Đã có lỗi xảy ra, vui lòng thử lại";
    }
    context.commit("SET_LOADING", false);
    return mess;
  },
};
